<template>
  <div class="step2">
    <van-nav-bar
      title="巨量百应账号身份认证"
      left-arrow
      fixed
      placeholder
      @click-left="$router.go(-1)"
    />
    <div class="main">
      <div class="box">
        <p class="title">账号身份认证说明</p>
        <p class="tips">
          1.完成账号身份认证，该身份认证信息将互通至精选联盟平台，并为你开通相关服务，此后你可选品带货。
        </p>
        <p class="tips">
          2.你的精选联盟账号将自定与你巨量百应账号绑定的抖音账号完成绑定，且不允许解绑。
        </p>
        <p class="tips">
          3.认证身份将作为账号所有人，就账号下的所有行为承担相应法律责任，如：就绑定的抖音账号的带货行为承担相应法律责任，收取商家佣金，提现佣金发票。
        </p>
        <p class="tips">
          4.你应就佣金等收入依法纳税，并自行承担个人所得税、增值税及附加税等税费成本。
        </p>
        <p class="tips">
          5.绑定抖音账号后，抖音账号如作为小店商家官方账号完成绑定，你账号的身份认证信息将变为小店商家认证主体。
        </p>
      </div>
    </div>
    <div class="bottom">
      <p class="text">
        开始认证视为同意<span>《精选联盟服务协议》</span>、<span>《联盟信息保护声明》</span>和<span
          >《账号绑定协议》</span
        >
      </p>
      <div class="btn" @click="handleStart">开始认证</div>
    </div>

    <van-popup
      v-model="show"
      closeable
      round
      position="bottom"
      :style="{ height: '93%' }"
    >
      <div style="padding: 15px">
        <p class="popup-title">抖音账号授权</p>
        <div class="logo-row">
          <el-image
            class="logo"
            :src="require('@/assets/images/simulation/buyin.svg')"
            fit="cover"
          ></el-image
          >申请
        </div>

        <div class="tips-container">
          <p class="tips-title">获取以下信息为你提供服务</p>
          <p class="tips-row">账号信息（手机号、头像、昵称）</p>
          <p class="tips-row">账号认证信息（认证身份、认证提交的资料）</p>
          <p class="tips-row">直播、视频及相关数据（含带货数据）</p>
          <p class="tips-row">直播间、橱窗操作权限</p>
          <p class="tips-row">
            [如有]绑定的千川账号的认证信息（认证身份、认证提交的资料）
          </p>

          <div style="margin-top: 25px">
            <p class="tips-text">提示：</p>
            <p class="tips-text">
              1.登录后，你的抖音账号将与巨量百应平台账号完成绑定，绑定后不允许解绑。
            </p>
            <p class="tips-text">
              2.如后续使用该巨量百应账号开通精选联盟平台服务，抖音账号将自定与精选联盟账号完成绑定，且你抖音账号带货全部收益将会结算至巨量百应平台账号认证主体的账户中。
            </p>
          </div>
        </div>

        <van-checkbox
          v-model="agree"
          checked-color="#ee0a24"
          icon-size="18px"
          style="margin-top: 20px; font-size: 12px"
          >已阅读并同意
          <span style="color: #3235dd">《巨量百应平台服务协议》</span>、
          <span style="color: #3235dd">《百应信息保护声明》</span>和
          <span style="color: #3235dd">《账号绑定协议》</span>
        </van-checkbox>

        <div class="btn" :class="{ disabled: !agree }" @click="onClick">
          授权并绑定
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { NavBar, Popup, Checkbox } from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      show: false,
      agree: false,
    };
  },
  methods: {
    handleStart() {
      if (!this.agree) this.show = true;
      else this.$router.replace("/simulation/douyinchuchuang/qualificationType");
    },
    onClick() {
      if (this.agree) this.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
.step2 {
  .main {
    padding: 10px;
    .box {
      padding: 15px;
      background-color: #fff;
      .title {
        margin-bottom: 10px;
        font-size: 16px;
      }
      .tips {
        margin-bottom: 10px;
        color: #909399;
      }
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    padding: 10px;
    width: 100%;
    background-color: #f9f9f9;
    box-shadow: 0 -8px 12px #f9f9f9;
    .text {
      margin-bottom: 10px;
      color: #909399;
      span {
        color: #3235dd;
      }
    }
    .btn {
      padding: 10px 0;
      text-align: center;
      color: #fff;
      background-color: #e21e48;
      border-radius: 3px;
      cursor: pointer;
    }
  }

  .popup-title {
    padding: 5px 0;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .logo-row {
    margin: 20px 0;
    .logo {
      margin-right: 10px;
      width: 120px;
      vertical-align: middle;
    }
  }
  .tips-container {
    .tips-title {
      margin-bottom: 20px;
      color: #606266;
      font-size: 20px;
      // font-weight: bold;
    }
    .tips-row {
      position: relative;
      padding-left: 15px;
      margin-bottom: 10px;
      color: #909399;
      &::before {
        content: "";
        position: absolute;
        top: 7px;
        left: 0;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #909399;
      }
    }
    .tips-text {
      margin-bottom: 10px;
      color: #909399;
    }
  }
  .btn {
    margin-top: 10px;
    padding: 10px 0;
    text-align: center;
    color: #fff;
    background-color: #e21e48;
    border-radius: 3px;
    cursor: pointer;
    &.disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
}
</style>